import "./Products01.css";
import React, { useState } from "react";

import tyres from "./../../../img/cont/tyres-1.webp";

function Products01() {
  const [activeIndex, setActiveIndex] = useState(0);

  const products = [
    {
      title: "Advanced Pyrolysis Products",
      description:
        "Our pyrolysis technology unlocks the maximum value from every tyre by breaking it down into high-grade commodities.",
      list: (
        <ul>
          <h4>Tyre Pyrolysis Oil (TPO)</h4>
          <li>
            A powerful and cost-effective oil used as a direct substitute for
            industrial fuels like furnace oil or diesel.
          </li>
          <h4>Recovered Carbon Black (rCB)</h4>
          <li>
            A valuable raw material used as a pigment and reinforcing agent in
            rubber and plastic manufacturing.
          </li>
        </ul>
      ),
    },
    {
      title: "High-Grade Rubber Crumb & Granules",
      description:
        "We process tyres into clean, uniform rubber crumb and granules, a versatile material with excellent properties for durability, sound absorption, and impact resistance",
      list: (
        <ul>
          <h4>Playground & Sports Surfaces:</h4>
          <li>
            The primary material for creating safe, durable, and
            weather-resistant surfaces for playgrounds, athletic tracks, and
            fitness areas.
          </li>
          <h4>Flooring & Matting:</h4>
          <li>
            Used to produce resilient and sound-absorbent rubber flooring and
            mats for residential, commercial, and industrial use.
          </li>
          <h4>Construction Materials:</h4>
          <li>
            Incorporated as an additive in concrete and asphalt to enhance crack
            resistance, durability, and impact absorption.
          </li>
          <h4>Acoustic & Thermal Insulation:</h4>
          <li>
            Crumb rubber is an effective material for improving thermal and
            sound insulation in buildings.
          </li>
          <h4>Noise Barriers:</h4>
          <li>
            Used in the construction of highly effective noise barriers along
            motorways and busy roads.
          </li>
          <h4>Roofing Materials:</h4>
          <li>
            Integrated into roofing shingles and membranes to provide superior
            durability and weather resistance.
          </li>
        </ul>
      ),
    },

    {
      title: "Tyre Derived Fuel (TDF) & Shreds",
      description:
        "Tyre Derived Fuel (TDF) is a high-energy, cost-effective fuel source used by heavy industry to reduce their reliance on fossil fuels.",
      list: (
        <ul>
          <h4>Industrial Fuel Source:</h4>
          <li>
            Widely used in facilities such as cement kilns and industrial
            boilers.
          </li>
          <h4>Erosion Control:</h4>
          <li>
            Tyre shreds are an effective material for stabilising slopes and
            embankments to prevent soil erosion
          </li>
        </ul>
      ),
    },
    {
      title: "Reclaimed & Repurposed Materials",
      list: (
        <ul>
          <h4>High-Tensile Steel</h4>
          <li>
            The steel wire and beading found in every tyre are recovered,
            cleaned, and sent back to steel mills for recycling into new
            products.
          </li>
          <h4>Tyre Sidewalls</h4>
          <li>
            Durable and heavy, cut tyre sidewalls are a popular and
            cost-effective solution for securing silage clamps on farms across
            the country.
          </li>
        </ul>
      ),
    },
  ];

  const toggleAnswer = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  return (
    <div className="Products01 section" id="Products01">
      <div className="container">
        <div className="Products01-box">
          <div className="Products01-box-left">
            <div>
              <p className="eyebrow green">Products </p>
              <h2>Sustainable Materials for a Circular Economy</h2>
              <p>
                At Global Tyres Recycling Ltd., we don't just dispose of
                waste—we re-manufacture it. Using advanced processing
                technologies like pyrolysis and mechanical shredding, we
                transform 100% of every end-of-life tyre into valuable,
                high-quality commodities for a wide range of UK industries.
                Explore the sustainable materials we produce.
              </p>
            </div>

            <img src={tyres} alt="" />
          </div>

          <div className="Products01-box-right">
            {products.map((product, index) => (
              <div key={index} onClick={() => toggleAnswer(index)}>
                <h3>{product.title}</h3>
                {activeIndex === index && (
                  <>
                    <p className="description">{product.description}</p>
                    {product.list}
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Products01;
